module.exports = __webpack_public_path__ + "img/sem-laudo-solicitado.7ee637ce.svg";